module.exports = __webpack_public_path__ + "img/1.5c1775b4.jpg";